import { useEffect } from 'react'

const EMBED_SCRIPT_SRC = 'https://link.msgsndr.com/js/form_embed.js'

export function useFormEmbedScript() {
  useEffect(() => {
    if (document.querySelector(`script[src="${EMBED_SCRIPT_SRC}"]`)) return
    const script = document.createElement('script')
    script.src = EMBED_SCRIPT_SRC
    script.async = true
    document.body.appendChild(script)
  }, [])
}
